import {
  TransferCandidatesTable,
  TransferCandidatesPageHeader,
} from './components';

function TransferCandidates() {
  return (
    <div className="p-10">
      <TransferCandidatesPageHeader />
      <TransferCandidatesTable />
    </div>
  );
}

export default TransferCandidates;
